/**
 * ============================================================================
 * DEMAND CATEGORY CHECKBOXES — QuickSight-parity control row (spec R10).
 * ============================================================================
 *
 * The CTS QuickSight Executive Summary has a checkbox row selecting which
 * DEMAND_CATEGORIES section groups are visible: "All Networks - On Time
 * Delivery %" (rollup) + the seven entries. This is our equivalent for the
 * Detailed Summary tab. Terminology matches the existing dashboard.
 *
 * Toggling recomputes client-side only (sections derive from the cached
 * rowset) — never a refetch. Selection persists via the dashboard slice.
 */

import React from 'react';
import Checkbox from '@amzn/awsui-components-core/checkbox';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import Box from '@amzn/awsui-components-core/box';
import { useAppDispatch, useAppSelector } from 'src/app/store';
import { demandCategoryToggled, allNetworksOtdToggled } from 'src/features/dashboard/dashboardSlice';
import {
  DEMAND_CATEGORY_IDS,
  DEMAND_CATEGORY_DISPLAY_NAMES,
} from 'src/config/demandCategories';

export const DemandCategoryCheckboxes: React.FC = () => {
  const dispatch = useAppDispatch();
  const selected = useAppSelector((state) => state.dashboard.selectedDemandCategories);
  const showAllNetworksOtd = useAppSelector((state) => state.dashboard.showAllNetworksOtd);

  return (
    <Box padding={{ vertical: 'xs' }}>
      <SpaceBetween direction="horizontal" size="l">
        <Checkbox
          checked={showAllNetworksOtd}
          onChange={({ detail }) => dispatch(allNetworksOtdToggled(detail.checked))}
        >
          All Networks - On Time Delivery %
        </Checkbox>
        {DEMAND_CATEGORY_IDS.map((id) => (
          <Checkbox
            key={id}
            checked={selected.includes(id)}
            onChange={() => dispatch(demandCategoryToggled(id))}
          >
            {DEMAND_CATEGORY_DISPLAY_NAMES[id]}
          </Checkbox>
        ))}
      </SpaceBetween>
    </Box>
  );
};
